// extracted by mini-css-extract-plugin
export default {"description":"Lightbox_description__e1X2W","lightbox":"Lightbox_lightbox__sxLji"};